import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { APICALL } from 'helper/api/api';
import { currencySign, SERVER_ERR, SOMETHING_ERR } from 'helper/Constant';
import BTNLoading from 'helper/my-com/BTNLoading';
import { auth, defaultIMG, emptyIMG, imgBaseURL, timeAgo, toastifyError, toastifySuccess } from 'helper/Utility';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Col, Row, Table } from "react-bootstrap";
import RateBtn from 'views/Component/RateBtn';

const formatDate = (dateStr) => {
    if (!dateStr) return "-"
    const date = new Date(dateStr)
    if (isNaN(date)) {
        // if string like "2024-08-15" just format it directly
        const [year, month, day] = dateStr.split("-")
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        return `${day} ${months[parseInt(month) - 1]} ${year}`
    }
    const day = date.getDate().toString().padStart(2, "0")
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    const month = months[date.getMonth()]
    const year = date.getFullYear()
    return `${day} ${month} ${year}`
}

const Booking = () => {
    const stripe = useStripe()
    const elements = useElements()
    const [bookingList, setBookingList] = useState([])
    const [cancelPopup, setCancelPopup] = useState({ show: false, bookingId: null, reason: "" })
    const [cancelLoader, setCancelLoader] = useState(false)
    const [tooltip, setTooltip] = useState({ id: null, x: 0, y: 0 })
    const [payPopup, setPayPopup] = useState({ show: false, bookingId: null, total: 0 })
    const [stripErr, setStripErr] = useState(null)
    const [payLoading, setPayLoading] = useState(false)

    useEffect(() => {
        getBookingFun()
    }, [])

    const getBookingFun = async () => {
        try {
            const params = { role: "User" }
            const res = await APICALL("admin/getAllBookings", "post", params)
            if (res?.status) {
                setBookingList(res?.data)
            } else {
                setBookingList([])
            }
        } catch (error) {
            console.log(error)
        }
    }

    const cancelBooking = async () => {
        if (!cancelPopup.reason.trim()) {
            toastifyError("Please enter a reason")
            return
        }
        setCancelLoader(true)
        try {
            const params = {
                bookingId: cancelPopup.bookingId,
                reason: cancelPopup.reason
            }
            const res = await APICALL(`${cancelPopup === "Reject" ? "admin" : "user"}/cancelBooking`, "post", params)
            if (res?.status) {
                toastifySuccess(res?.message)
                setCancelPopup({modalName: "",  show: false, bookingId: null, reason: "" })
                getBookingFun()
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            toastifyError(error?.response?.data?.message || SERVER_ERR)
        } finally {
            setCancelLoader(false)
        }
    }

    const payNow = async () => {
        setPayLoading(true)
        const res = await APICALL("user/createPaymentInstant", "post", { amount: payPopup?.total })
        if (res?.status == 200) {
            const clientSecret = res?.data?.paymentIntent
            const payload = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement)
                }
            })

            if (payload?.paymentIntent?.status == "succeeded") {
                setStripErr(null)
                const params = {
                    bookingId: payPopup?.bookingId,
                    paymentMethod: "stripe",
                    paymentResponse: {
                        transactionId: payload?.paymentIntent?.id,
                        currency: "USD",
                        ...payload?.paymentIntent
                    }
                }
                try {
                    const res = await APICALL("/admin/payBooking", "post", params)
                    if (res?.status) {
                        toastifySuccess(res?.message)
                        setPayPopup({ show: false, bookingId: null, total: 0 })
                        getBookingFun()
                    } else {
                        toastifyError(SOMETHING_ERR)
                    }
                } catch (error) {
                    toastifyError(error?.response?.data?.message || SERVER_ERR)
                } finally {
                    setPayLoading(false)
                }
            } else {
                setStripErr(`Payment failed - Somthing wrong !!`)
                setPayLoading(false)

            }
            if (payload.error) {
                setStripErr(`Payment failed ${payload.error.message}`)
                setPayLoading(false)
            }
        }
    }

    const isBeforeBookingDateTime = (bookingDate, bookingTime) => {
        if (!bookingDate || !bookingTime) return false;

        const [hours, minutes] = bookingTime.split(':');
        const bookingDateTime = moment(bookingDate)
            .set({ hour: parseInt(hours), minute: parseInt(minutes), second: 0 });

        return moment().isBefore(bookingDateTime);
    }

    return (
        <>
            <div className="selller_edit_sellpromain">
                <div className="nn_edit_proname">Bookings</div>
                <div className="seller_edit_sellpro">
                    {bookingList?.length > 0 ? (
                        <Row className="seller_edit_sellpro_inner">
                            <div className="nn_order_details-pay table-responsive p-0">
                                <Table className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Product Title</th>
                                            <th>Price</th>
                                            <th>Date & Time</th>
                                            <th>Booking Status</th>
                                            <th>Vendor</th>
                                            <th className="text-end">Booking Date</th>
                                            <th className="text-end">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookingList?.map((item, idx) => (
                                            <tr key={idx}>
                                                <td width="20%">
                                                    <div className="imgwithtitle">
                                                        <img
                                                            src={item?.productId?.gallery?.length > 0 ? imgBaseURL() + item?.productId?.gallery[0] : defaultIMG}
                                                            alt=""
                                                        />
                                                        {item?.productId?.title}
                                                    </div>
                                                </td>
                                                <td>{currencySign}{item?.total}</td>
                                                <td>
                                                    <span style={{ display: "block", fontWeight: "500", fontSize: "13px" }}>
                                                        📅 {formatDate(item?.date)}
                                                    </span>
                                                    <span style={{ fontSize: "12px", color: "#888" }}>
                                                        🕐 {item?.time}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div style={{ display: "inline-flex", flexDirection: "column", gap: "6px" }}>

                                                        {/* Status Badge */}
                                                        <span style={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "5px 12px",
                                                            borderRadius: "20px",
                                                            fontSize: "12px",
                                                            fontWeight: "600",
                                                            textTransform: "capitalize",
                                                            background: item?.bookingStatus === "cancelled" ? "#fee2e2"
                                                                : (item?.bookingStatus === "approved" || item?.bookingStatus === "paid") ? "#dcfce7"
                                                                    : "#fef3c7",
                                                            color: item?.bookingStatus === "cancelled" ? "#dc2626"
                                                                : (item?.bookingStatus === "approved" || item?.bookingStatus === "paid") ? "#16a34a"
                                                                    : "#d97706",
                                                        }}>

                                                            {item?.bookingStatus}

                                                            {/* Info icon inside badge - only for cancelled */}
                                                            {item?.bookingStatus === "cancelled" && item?.cancellationReason && (
                                                                <span
                                                                    onMouseEnter={(e) => {
                                                                        const rect = e.currentTarget.getBoundingClientRect()
                                                                        setTooltip({ id: idx, x: rect.left, y: rect.top })
                                                                    }}
                                                                    onMouseLeave={() => setTooltip({ id: null, x: 0, y: 0 })}
                                                                    style={{ position: "relative", display: "inline-flex", alignItems: "center", cursor: "pointer" }}
                                                                >
                                                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                        <circle cx="12" cy="12" r="10" />
                                                                        <line x1="12" y1="8" x2="12" y2="12" />
                                                                        <line x1="12" y1="16" x2="12.01" y2="16" />
                                                                    </svg>

                                                                    {tooltip.id === idx && (
                                                                        <span style={{
                                                                            position: "fixed",
                                                                            top: tooltip.y - 10,
                                                                            left: tooltip.x - 290,
                                                                            background: "#fff",
                                                                            border: "1px solid #fecaca",
                                                                            borderLeft: "3px solid #dc2626",
                                                                            color: "#374151",
                                                                            fontSize: "11px",
                                                                            fontWeight: "400",
                                                                            padding: "8px 12px",
                                                                            borderRadius: "6px",
                                                                            whiteSpace: "normal",
                                                                            width: "220px",
                                                                            zIndex: 9999,
                                                                            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                                                                            pointerEvents: "none",
                                                                            lineHeight: "1.5",
                                                                            transform: "translateY(-100%)",
                                                                        }}>
                                                                            <span style={{ display: "block", fontWeight: "600", color: "#dc2626", marginBottom: "3px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                                                                Cancellation Reason
                                                                            </span>
                                                                            {item?.cancellationReason}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{item?.vendorId?.fullName}</td>
                                                <td className="text-end">{timeAgo(item?.createdAt)}</td>
                                                <td className="text-end">
                                                    {
                                                        (item?.bookingStatus == "paid") &&
                                                        <>
                                                            {!item?.isRating
                                                                ? <RateBtn className="" data={item} callFun={getBookingFun} />
                                                                : <p className='alredy_raded'>Rated</p>
                                                            }
                                                        </>
                                                    }

                                                    {(item?.paymentStatus === "paid" && item?.bookingStatus != "cancelled" && isBeforeBookingDateTime(item?.date, item?.time)) && (
                                                        <>
                                                            <button
                                                                className='editbtn-small px-2 mx-1'
                                                                style={{ background: "#dc3545c4", color: "#fff", border: "none" }}
                                                                onClick={() => setCancelPopup({ modalName: 'Cancel', show: true, bookingId: item?._id, reason: "" })}
                                                            >
                                                                Cancel Booking
                                                            </button>
                                                        </>
                                                    )}

                                                    {
                                                        (item?.bookingStatus == "pending") &&
                                                        <button
                                                            className='myplo_addressbtn1 ms-2 px-3'
                                                            onClick={() => setCancelPopup({ modalName: 'Reject',show: true, bookingId: item?._id, reason: "" })}
                                                        >
                                                            Cancel Booking
                                                        </button>
                                                    }

                                                    {item?.bookingStatus === "approved" && (
                                                        <button
                                                            className='myplo_addressbtn1 ms-2 px-3'
                                                            onClick={() => setPayPopup({ show: true, bookingId: item?._id, total: item?.total })}
                                                        >
                                                            Pay
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Row>
                    ) : (
                        <div className="nn_empty_tab text-center">
                            <img src={emptyIMG} alt="Empty" />
                            <p>
                                <strong className="text-black">You have't been booked.. yet.</strong><br />
                                When the party planners find you, your bookings will show up here!
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* Cancel Popup */}
            {cancelPopup.show && (
                <div style={{
                    position: "fixed", inset: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    zIndex: 9999
                }}>
                    <div style={{
                        background: "#fff", borderRadius: "12px",
                        padding: "28px 24px", width: "100%", maxWidth: "420px",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.15)"
                    }}>
                        <h5 style={{ marginBottom: "6px", fontWeight: "700", fontSize: "16px" }}>
                            Cancel Booking
                        </h5>
                        <p style={{ fontSize: "13px", color: "#666", marginBottom: "16px" }}>
                            Please provide a reason for cancellation.
                        </p>

                        <textarea
                            rows={4}
                            placeholder="Enter reason..."
                            value={cancelPopup.reason}
                            onChange={(e) => setCancelPopup({ ...cancelPopup, reason: e.target.value })}
                            style={{
                                width: "100%", borderRadius: "8px",
                                border: "1px solid #e2e8f0", padding: "10px 12px",
                                fontSize: "13px", resize: "none", outline: "none"
                            }}
                        />

                        <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
                            <button
                                disabled={cancelLoader}
                                onClick={() => setCancelPopup({ show: false, bookingId: null, reason: "" })}
                                style={{
                                    flex: 1, padding: "10px", borderRadius: "8px",
                                    border: "1px solid #e2e8f0", background: "#f8fafc",
                                    fontSize: "13px", fontWeight: "600", cursor: "pointer"
                                }}>
                                Back
                            </button>
                            <button
                                onClick={cancelBooking}
                                disabled={cancelLoader}
                                style={{
                                    flex: 1, padding: "10px", borderRadius: "8px",
                                    border: "none", background: "#dc2626", color: "#fff",
                                    fontSize: "13px", fontWeight: "600", cursor: cancelLoader ? "not-allowed" : "pointer",
                                    opacity: cancelLoader ? 0.8 : 1,
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px"
                                }}>
                                {cancelLoader ? (
                                    <>
                                        <span style={{
                                            width: "14px", height: "14px", border: "2px solid #fff",
                                            borderTop: "2px solid transparent", borderRadius: "50%",
                                            display: "inline-block", animation: "spin 0.7s linear infinite"
                                        }} />
                                        Cancelling...
                                    </>
                                ) : "Confirm Cancel"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {payPopup.show && (
                <div style={{
                    position: "fixed", inset: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    zIndex: 9999
                }}>
                    <div style={{
                        background: "#fff", borderRadius: "12px",
                        padding: "28px 24px", width: "100%", maxWidth: "400px",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.15)", textAlign: "center"
                    }}>
                        <div style={{
                            width: "56px", height: "56px", borderRadius: "50%",
                            background: "#dbeafe", display: "flex", alignItems: "center",
                            justifyContent: "center", margin: "0 auto 16px", fontSize: "24px"
                        }}>
                            💳
                        </div>
                        <h5 style={{ fontWeight: "700", fontSize: "16px", marginBottom: "6px" }}>
                            Confirm Payment
                        </h5>
                        <p style={{ fontSize: "13px", color: "#666", marginBottom: "20px" }}>
                            You need to pay <strong>20% advance</strong> to confirm this booking.
                        </p>

                        {/* Amount Breakdown */}
                        <div style={{
                            background: "#f8fafc", borderRadius: "10px",
                            padding: "14px 16px", marginBottom: "20px", textAlign: "left"
                        }}>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#64748b", marginBottom: "8px" }}>
                                <span>Total Amount</span>
                                <span>{currencySign}{payPopup.total}</span>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#64748b", marginBottom: "8px" }}>
                                <span>Advance (20%)</span>
                                <span style={{ color: "#2563eb", fontWeight: "600" }}>
                                    {currencySign}{(payPopup.total * 0.20).toFixed(2)}
                                </span>
                            </div>
                            <div style={{ borderTop: "1px solid #e2e8f0", marginTop: "8px", paddingTop: "8px", display: "flex", justifyContent: "space-between", fontSize: "14px", fontWeight: "700" }}>
                                <span>Payable Now</span>
                                <span style={{ color: "#2563eb" }}>{currencySign}{(payPopup.total * 0.20).toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="col-12">
                            <CardElement className="card-stripe-element" />
                            {stripErr && <div className="stripe-error-msg mt-2 text-danger">{stripErr}</div>}
                            <div className="mt-2">
                                <span>All payments are processed securely through Stripe. MyPlo never stores your card details</span>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: "10px" }} className='mt-3'>
                            <button
                                onClick={() => setPayPopup({ show: false, bookingId: null, total: 0 })}
                                style={{
                                    flex: 1, padding: "10px", borderRadius: "8px",
                                    border: "1px solid #e2e8f0", background: "#f8fafc",
                                    fontSize: "13px", fontWeight: "600", cursor: "pointer"
                                }}>
                                Cancel
                            </button>
                            {
                                payLoading ?
                                    <button
                                        style={{
                                            flex: 1, padding: "10px", borderRadius: "8px",
                                            border: "none", background: "#2563eb", color: "#fff",
                                            fontSize: "13px", fontWeight: "600", cursor: "pointer"
                                        }}>
                                        Loading...
                                    </button>
                                    :
                                    <button
                                        onClick={() => payNow()}
                                        style={{
                                            flex: 1, padding: "10px", borderRadius: "8px",
                                            border: "none", background: "#2563eb", color: "#fff",
                                            fontSize: "13px", fontWeight: "600", cursor: "pointer"
                                        }}>
                                        Pay {currencySign}{(payPopup.total * 0.20).toFixed(2)}
                                    </button>
                            }
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </>
    )
}

export default Booking